/* Festive gift box reveal. Runs inside the lucky sheet iframe; the parent page owns signup (see snippets/dt-festive-lucky-demo.liquid). */
(() => {
  const gift = document.getElementById('gift');
  if (!gift) return;
  const box = document.getElementById('box');
  const card = document.getElementById('card');
  const cardLift = document.getElementById('card-lift');
  const uiTop = document.getElementById('ui-top');
  const uiBottom = document.getElementById('ui-bottom');
  const particles = document.getElementById('particles');
  const codeEl = document.getElementById('code');
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Browsers accept addresses like name@domain; the parent's signup needs a full domain, so check the same rule here.
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const TEXT = {
    saving: gift.dataset.saving || 'Saving your email…',
    error: gift.dataset.error || 'We couldn’t save your email. Please try again.',
    consent: gift.dataset.consent || ''
  };
  // Codes live in Shopify (Discounts); keep amounts and minimums here in step with them. Weights add up to 100.
  const OFFERS = [
    { code: 'DT200', amount: '₹200', sub: 'on orders ₹899+', weight: 50 },
    { code: 'HAIR350', amount: '₹350', sub: 'on banana hair towels', weight: 35 },
    { code: 'EXTRA5', amount: '5%', sub: 'on orders ₹999+', weight: 15 }
  ];
  let offer = pickOffer();
  let timers = [];
  let petalFrame = 0;
  let submitting = false;

  function pickOffer() {
    const random = new Uint32Array(1);
    crypto.getRandomValues(random);
    let roll = random[0] / 4294967296 * OFFERS.reduce((sum, item) => sum + item.weight, 0);
    return OFFERS.find((item) => (roll -= item.weight) < 0) || OFFERS[0];
  }

  function applyOffer(next) {
    offer = next;
    document.getElementById('offer-amount').textContent = offer.amount;
    document.getElementById('offer-sub').textContent = offer.sub;
    codeEl.textContent = offer.code;
  }

  // Tell the parent page which funnel step the shopper reached; it forwards these to analytics.
  const reportStep = (step) => window.parent.postMessage({ type: 'dt-lucky-demo:step', step, offer: offer.code }, '*');
  const later = (fn, ms) => timers.push(setTimeout(fn, REDUCED ? Math.min(ms, 50) : ms));
  const escapeHtml = (value) => value.replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[ch]);

  const COPY = {
    enter: ['A Diwali gift from Doctor Towels', '<h2>There’s something <span>inside.</span></h2>'],
    idle: ['A Diwali gift from Doctor Towels', '<h2>There’s something <span>inside.</span></h2>'],
    open: ['', '<h2>Opening your <span>gift…</span></h2>'],
    land: ['You unlocked', ''],
    flip: ['You unlocked', ''],
    back: ['', () => '<h2>Unlock your <span>code.</span></h2><form class="email" id="email-form" novalidate><input id="email" name="email" type="email" required maxlength="254" placeholder="Your email" autocomplete="email" aria-label="Email address"><button type="submit" id="email-submit" aria-label="Unlock code">→</button></form><p class="message" id="message" role="status" aria-live="polite"></p><p class="consent">' + escapeHtml(TEXT.consent) + '</p>'],
    code: ['', '<h2>It’s your <span>lucky day.</span></h2><button class="copy" id="copy" type="button">Copy code</button><p class="consent" id="copy-note" role="status" aria-live="polite">Apply at checkout.</p>']
  };

  function setState(state) {
    gift.dataset.state = state;
    render(state);
  }

  function render(state) {
    const [top, bottomSource] = COPY[state];
    const bottom = typeof bottomSource === 'function' ? bottomSource() : bottomSource;
    uiTop.textContent = top;
    if (uiBottom.dataset.html === bottom) return;
    uiBottom.dataset.html = bottom;
    uiBottom.innerHTML = bottom;
    if (!REDUCED) [...uiBottom.children].forEach((el, i) => el.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 380, delay: 80 + i * 70, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }));
    const form = document.getElementById('email-form');
    if (form) {
      form.addEventListener('submit', submitEmail);
      document.getElementById('email').focus({ preventScroll: true });
    }
    const copy = document.getElementById('copy');
    if (copy) copy.addEventListener('click', copyCode);
  }

  function submitEmail(event) {
    event.preventDefault();
    const input = document.getElementById('email');
    const message = document.getElementById('message');
    input.value = input.value.trim();
    if (submitting) return;
    if (!input.checkValidity() || !EMAIL_PATTERN.test(input.value)) { message.textContent = 'Please enter a full email address, like name@gmail.com.'; input.focus(); return; }
    submitting = true;
    document.getElementById('email-submit').disabled = true;
    message.textContent = TEXT.saving;
    window.parent.postMessage({ type: 'dt-lucky-demo:subscribe', email: input.value, prize: offer.code }, '*');
  }

  async function copyCode() {
    const note = document.getElementById('copy-note');
    reportStep('code_copied');
    try { await navigator.clipboard.writeText(offer.code); this.textContent = 'Copied'; note.textContent = 'Apply ' + offer.code + ' at checkout.'; }
    catch { note.textContent = 'Your code is ' + offer.code + '. Apply at checkout.'; }
  }

  function burstPetals() {
    if (REDUCED) return;
    const COLORS = ['#f59e2b', '#e8622a', '#f3c64f', '#d9481c', '#f6b26b'];
    const GRAVITY = 420, DRAG = 1.9, LIFETIME = 3.4;
    const origin = { x: gift.clientWidth / 2, y: gift.clientHeight * .34 };
    const petals = Array.from({ length: 22 }, (_, i) => {
      const el = document.createElement('i');
      el.className = 'petal';
      el.style.background = COLORS[i % COLORS.length];
      particles.appendChild(el);
      const angle = -Math.PI / 2 + (Math.random() - .5) * Math.PI * 1.25;
      const speed = 260 + Math.random() * 220;
      return { el, x: origin.x + (Math.random() - .5) * 40, y: origin.y, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed,
        rot: Math.random() * 360, spin: (Math.random() - .5) * 240, phase: Math.random() * Math.PI * 2, sway: 18 + Math.random() * 22,
        flutter: 3 + Math.random() * 3, size: .7 + Math.random() * .6, life: LIFETIME - Math.random() * .8 };
    });
    let last = performance.now(), age = 0;
    const step = (now) => {
      const dt = Math.min((now - last) / 1000, 1 / 30); last = now; age += dt;
      let alive = 0;
      for (const p of petals) {
        if (age > p.life) { p.el.remove(); continue; }
        alive++;
        p.vx -= p.vx * DRAG * dt;
        p.vy += (GRAVITY - p.vy * DRAG) * dt;
        p.x += p.vx * dt + Math.cos(age * 2.2 + p.phase) * p.sway * dt;
        p.y += p.vy * dt;
        p.rot += p.spin * dt;
        p.el.style.opacity = Math.min(1, age / .15, (p.life - age) / .6).toFixed(3);
        p.el.style.transform = `translate(${p.x}px, ${p.y}px) rotate(${p.rot}deg) scale(${p.size}, ${(p.size * Math.cos(age * p.flutter + p.phase)).toFixed(3)})`;
      }
      if (alive) petalFrame = requestAnimationFrame(step);
    };
    petalFrame = requestAnimationFrame(step);
  }

  function lightBurst() {
    if (REDUCED) return;
    const [rays] = document.getElementById('burst-back').children;
    const [halo, flash, ring] = document.getElementById('burst-front').children;
    const ease = 'cubic-bezier(.22,1,.36,1)';
    flash.animate([{ opacity: 0, scale: .2 }, { opacity: .95, scale: 1, offset: .18 }, { opacity: 0, scale: 2.2 }], { duration: 700, easing: ease });
    ring.animate([{ opacity: .9, scale: .3 }, { opacity: 0, scale: 3.2 }], { duration: 900, easing: ease });
    halo.animate([{ opacity: 0, scale: .4 }, { opacity: .7, scale: 1, offset: .2 }, { opacity: .25, scale: 1.05, offset: .5 }, { opacity: 0, scale: 1.1 }], { duration: 1400, easing: ease });
    rays.animate([{ opacity: 0, scale: .5, rotate: '0deg' }, { opacity: 1, scale: 1, offset: .25 }, { opacity: 0, scale: 1.15, rotate: '40deg' }], { duration: 2200, easing: ease });
  }

  // One continuous reveal: lift, spin and scale each run on their own curve, so there is no hand-off between steps.
  function revealCard() {
    if (REDUCED) return;
    const reveal = [
      gift.animate([{ '--cy': '0px', '--cz': '0px' }, { '--cy': '-60px', '--cz': '50px' }], { duration: 1500, easing: 'cubic-bezier(.2, .85, .25, 1)', fill: 'both' }),
      gift.animate([{ '--cry': '-14deg', '--crx': '-26deg' }, { '--cry': '352deg', '--crx': '4deg' }], { duration: 1900, delay: 90, easing: 'cubic-bezier(.4, 0, .12, 1)', fill: 'both' }),
      gift.animate([{ '--cs': '.55' }, { '--cs': '1.08' }], { duration: 1600, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' })
    ];
    Promise.all(reveal.map((a) => a.finished)).then(() => reveal.forEach((a) => a.cancel())).catch(() => {});
  }

  function openBox() {
    if (gift.dataset.state !== 'idle') return;
    reportStep('box_opened');
    setState('open');
    later(() => { setState('land'); revealCard(); lightBurst(); }, 520);
    later(burstPetals, 1500);
  }

  function flipCard() {
    if (gift.dataset.state !== 'land') return;
    reportStep('card_flipped');
    setState('flip');
    if (!REDUCED) cardLift.animate([{ transform: 'none', easing: 'cubic-bezier(.33, 0, .67, 1)' }, { transform: 'translateZ(56px)', offset: .5, easing: 'cubic-bezier(.33, 0, .67, 1)' }, { transform: 'none' }], { duration: 900 });
    later(() => setState('back'), 920);
  }

  function revealCode() {
    setState('code');
    if (!REDUCED) codeEl.animate([{ boxShadow: '0 0 0 0 rgba(243,213,143,0)' }, { boxShadow: '0 0 0 6px rgba(243,213,143,.7)' }, { boxShadow: '0 0 0 12px rgba(243,213,143,0)' }], { duration: 700, delay: 250 });
    document.getElementById('copy')?.focus({ preventScroll: true });
  }

  // Returning from Shopify's bot check: jump straight to the revealed code.
  function showSavedCoupon(code) {
    const saved = OFFERS.find((item) => item.code === code);
    if (!saved) return;
    timers.forEach(clearTimeout); timers = [];
    applyOffer(saved);
    gift.classList.add('no-motion');
    setState('code');
    void gift.offsetWidth;
    gift.classList.remove('no-motion');
  }

  window.addEventListener('message', (event) => {
    if (event.source !== window.parent || !event.data) return;
    if (event.data.type === 'dt-lucky-demo:show-coupon') { showSavedCoupon(String(event.data.code || '')); return; }
    if (event.data.type !== 'dt-lucky-demo:subscribe-result') return;
    submitting = false;
    if (event.data.ok) { revealCode(); return; }
    const submit = document.getElementById('email-submit');
    if (submit) submit.disabled = false;
    const message = document.getElementById('message');
    if (message) message.textContent = TEXT.error;
    document.getElementById('email')?.focus();
  });

  box.addEventListener('click', openBox);
  // The scene itself is the tap target: it opens the waiting box and flips the landed card. iOS Safari can miss
  // the first tap on a moving 3D element, so a tap that lands just beside it still counts.
  document.querySelector('.stage').addEventListener('click', () => {
    if (gift.dataset.state === 'idle') openBox();
    else if (gift.dataset.state === 'land') flipCard();
  });
  // Scale the 640px-tall design canvas down to fit short sheets.
  const DESIGN_HEIGHT = 640;
  function fitCanvas() {
    const height = window.innerHeight;
    const fit = Math.min(1, height / DESIGN_HEIGHT);
    gift.classList.toggle('is-fitted', fit < 1);
    gift.style.setProperty('--fit', String(fit));
    gift.style.setProperty('--fit-w', (window.innerWidth / fit) + 'px');
    gift.style.setProperty('--fit-h', DESIGN_HEIGHT + 'px');
  }
  fitCanvas();
  window.addEventListener('resize', fitCanvas);
  box.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openBox(); } });
  card.addEventListener('click', flipCard);
  card.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flipCard(); } });
  document.getElementById('cta').addEventListener('click', (event) => { event.stopPropagation(); flipCard(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') window.parent.postMessage({ type: 'dt-lucky-demo:close' }, '*'); });

  applyOffer(offer);
  setState('enter');
  later(() => setState('idle'), 900);
})();
